import { useOnSurfaceNodeSave } from 'components/canvas/hooks/use-on-surface-node-save';
import useMutation from 'hooks/use-mutation';
import { useParams } from 'react-router';
import { createSurfaceDocumentNodeMutation } from 'graphql/surface-node/mutations/surface-document-node/create-surface-document-node';
import { updateSurfaceDocumentNodeMutation } from 'graphql/surface-node/mutations/surface-document-node/update-surface-document-node';
import { createSurfaceRisDocumentNodeMutation } from 'graphql/surface-node/mutations/surface-document-node/create-surface-ris-document-node';
import { surfaceNodesQuery } from 'graphql/surface-node/queries/surface-nodes';
import { pick } from 'lodash';

export default function useSaveSurfaceDocumentNode(surfaceId) {
  const { id } = useParams();

  const onSurfaceDocumentNodeCreate = useOnSurfaceNodeSave(
    'createSurfaceDocumentNode',
  );

  const onSurfaceDocumentNodeUpdate = useOnSurfaceNodeSave(
    'updateSurfaceDocumentNode',
  );

  const [createSurfaceDocumentNode] = useMutation(
    createSurfaceDocumentNodeMutation,
    {
      // update: onSurfaceDocumentNodeCreate as any,
    },
  );

  const onSurfaceRisDocumentNodeCreate = useOnSurfaceNodeSave(
    'createSurfaceRisDocumentNode',
  );

  const [createSurfaceRisDocumentNode] = useMutation(
    createSurfaceRisDocumentNodeMutation,
    {
      update: onSurfaceRisDocumentNodeCreate as any,
    },
  );

  const [updateSurfaceDocumentNode] = useMutation(
    updateSurfaceDocumentNodeMutation,
    {
      update: onSurfaceDocumentNodeUpdate as any,
    },
  );

  return function saveSurfaceDocumentNode(params) {
    const isUpdate = params.variables.input?.id;

    parseSnippets(params);

    if (isUpdate) {
      parseDocumentFormat(params);

      params.variables.input = pick(params.variables.input, [
        'id',
        'name',
        'instantJSON',
        'format',
        'snippets',
      ]);

      return updateSurfaceDocumentNode(params);
    }

    console.log("XXX PARAMS" , params   )
    
    params.variables.input = pick(params.variables.input, [
      'surface',
      'name',
      'url',
      'instantJSON',
      'format',
      'position',
      'snippets',
      'mimeType'
    ]);


    if (params.variables.input?.url && params.variables.input?.url.startsWith("http")) {
      return createSurfaceRisDocumentNode(params);
    }

    params.variables.input = pick(params.variables.input, [
      'surface',
      'name',
      // 'url',
      'instantJSON',
      'format',
      'position',
      'snippets',
      'mimeType'
    ]);


    return createSurfaceDocumentNode(params);
  };
}

function parseDocumentFormat(params) {
  if (params.variables?.input?.documentFormat) {
    params.variables.input.format = params.variables?.input?.documentFormat;
  }
}

function parseSnippets(params) {
  if (params.variables?.input?.snippets) {
    params.variables.input.snippets = params.variables?.input?.snippets?.map(
      (snippet) =>
        pick(snippet, ['id', 'annotationId', 'name', 'text', 'operation']),
    );
  }
}
